import { DotsSixIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const SquareMenu = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <DotsSixIcon size={Sizes[size]} {...rest} color={fill} />;
};

SquareMenu.displayName = 'SquareMenu';
